import { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'

import { Box, Tabs, Tab, ButtonGroup, Button } from '@mui/material'

import { AppContext } from "/providers/app-context"
import { getSystemTemplates } from '/providers/templates-api'
import QrCode2Icon from '@mui/icons-material/QrCode2'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/create-new-template'
import Templates from '/components/new-template/template-list'
import SelectedTemplateDialog from '/components/new-template/selected-template-dialog'


const CreateNewTemplate = () => {
  const { apiSource, apiKeys } = useContext(AppContext)

  const [templates, setTemplates] = useState([])
  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const [open, setOpen] = useState(false)
  const [tabIndex, setTabIndex] = useState("standard")

  useEffect(() => {
    initialise()
  }, [])

  useEffect(() => {
    setOpen(selectedTemplate === null ? false : true)
  }, [selectedTemplate])

  useEffect(() => {
    if (!open) setSelectedTemplate(null)
  }, [open])

  const initialise = async () => {
    const tps = await getSystemTemplates({ apiSource, apiKeys })

    //TODO handle error
    if (!tps.error) {
      tps.map(t => {
        t.apple_skeleton = t.apple_pass_type
        if (t.apple_sub_type && ! /PKTransit/.test(t.apple_sub_type)) {
          t.apple_skeleton += "-" + t.apple_sub_type.toLowerCase()
        }
      })

      setTemplates(tps)
    }
  }

  const Menu = () => (
    <div className='flex flex-row justify-end whitespace-nowrap'>
      <ButtonGroup variant="text" aria-label="Actions">
        <Button onClick={() => setTabIndex("standard")} sx={{ color: tabIndex === "standard" ? "link" : "text.secondary" }}>Standard Templates</Button>
        <Button onClick={() => setTabIndex("managed")} sx={{ color: tabIndex === "managed" ? "link" : "text.secondary" }}>Managed Templates</Button>
        <Button onClick={() => setTabIndex("specialist")} sx={{ color: tabIndex === "specialist" ? "link" : "text.secondary" }}>Specialist Templates</Button>
        <Button onClick={() => setTabIndex("examples")} sx={{ color: tabIndex === "examples" ? "link" : "text.secondary" }}>Example Templates</Button>
      </ButtonGroup>
    </div>
  )

  return (
    <PageWrapper title="Create New Template" heading="Create new template" HelpText={HelpText} menu={<Menu />}>
      <div className='mb-5 p-5'>
        <TemplateTypeInfo tabIndex={tabIndex} />
      </div>

      <div className='flex flex-wrap w-full gap-5  max-w-full mt-10 justify-center h-full pb-96 content-start dashboard'>
        <Templates templates={templates} tabIndex={tabIndex} selectedTemplate={selectedTemplate} setSelectedTemplate={setSelectedTemplate} />
      </div>
      <SelectedTemplateDialog open={open} setOpen={setOpen} template={selectedTemplate} />
    </PageWrapper >
  )
}

export default CreateNewTemplate

const TemplateTypeInfo = ({ tabIndex }) => {
  if (tabIndex === "standard") return (
    <>
      <p>These are templates where you fully control the content.
        You will be responsible for generating your own barcodes, and implementing your own scanning
        (You cannot use the <Link to="/download-apps" className='link'>Smartix Scanner App</Link>).</p>
      <p>Images below show example configurations. When you use this template you will start with a plain white pass with dummy images.</p>
    </>
  )

  if (tabIndex === "managed") return (
    <>
      <p>These templates can be used with the <Link to="/download-apps" className='link'>Smartix Scanner App</Link>. Smartix will
        generate barcodes for you and handle the processing when they are scanned with
        the <Link to="/download-apps" className='link'>Smartix Scanner App</Link></p>


      <p>You have more limited editing opportunities with these templates
        since Smartix must control some of the content and layout.
      </p>
    </>
  )

  if (tabIndex === "specialist") return (
    <>
      <p>These templates are not for general use. You may browse them here, but cannot select one.</p>
      <p>If you require one of these specialist templates, or require some specialist handling that cannot be provided by our standard templates then please <Link to="/support" className='link'>get in touch</Link>.</p>
    </>
  )

  if (tabIndex === "examples") return (
    <>
      <p>These are some example templates we have made using our standard and managed templates. Use them for inspiration, or feel free to copy and amend them for your own use.</p>
      <p>Images below show the configurations that will be installed. When you use this template you will start with the template you see below.</p>
      <p>Note: Managed templates show the <QrCode2Icon /> icon.</p>

    </>
  )
}
